import { html } from "../../../../../../../_ovlclient/src"
import { postRequest } from "../../../../../../../_ovlclient/src/effects"

import {
  FieldIsDirty,
  FieldIsVisible,
  FieldVal,
  SYSField,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormHasVisibleSummaryErrors,
  FormIsValid,
  FormSetUnDirty,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { SYSFormElement } from "../../../../../../../_ovlclient/src/library/forms/sysformelement"
import { ValidationsAdd } from "../../../../../../../_ovlclient/src/library/forms/validatorsapi"

import { ScreenNavigateTo } from "../../../../../../../_ovlclient/src/library/screenapi"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import { NewServiceStep1FormFieldKeys } from "../../../features/svl/svlnewservicestep1/formdef"
import { validateCaptcha } from "../../../global/helpers"

export class NewServiceStep1 extends SYSFormElement {
  async handleStep1(e: Event) {
    let emailDirty = FieldIsDirty(
      this.formState.fields[<NewServiceStep1FormFieldKeys>"requesterEmail"]
    )
    //SnackAdd(`@@Log: Email Field Dirty ${emailDirty}`)
    let promoVisible =
      FieldIsVisible(
        this.formState.fields[<NewServiceStep1FormFieldKeys>"promoCode2"]
      ) ||
      FieldIsVisible(
        this.formState.fields[<NewServiceStep1FormFieldKeys>"promoCode3"]
      )

    let isDirty = emailDirty || promoVisible

    let moveOn = false
    if (isDirty) {
      //console.log(this.state.app.global.SVL.NewService)
      let newService = this.state.app.global.SVL.NewService
      let fields = this.formState.fields
      let email = FieldVal(
        fields[<NewServiceStep1FormFieldKeys>"requesterEmail"]
      )
      //SnackAdd(`@@Log: Email from from ${email}`)
      let promoCode = ""
      if (this.state.app.global.SVL.NewService.promo.visible) {
        promoCode = `${FieldVal(
          fields[<NewServiceStep1FormFieldKeys>"promoCode"]
        )}-${FieldVal(
          fields[<NewServiceStep1FormFieldKeys>"promoCode2"]
        )}-${FieldVal(fields[<NewServiceStep1FormFieldKeys>"promoCode3"])}`
      }
      let token = await validateCaptcha()
      if (emailDirty) {
        newService.contact.cardGroup = ""
        newService.contact.id = ""
      }
      let res
      try {
        res = await postRequest(this.state.ovl.apiUrl + "step1/getstep1data", {
          Email: email,
          PromoCode: promoCode,
          emailDirty,
          promoDirty: promoVisible,
          token,
        })

        if (emailDirty && res.data) {
          newService.contact.cardGroup = res.data.cardGroup
          newService.contact.id = res.data.id

          newService.contact.email = email
          //SnackAdd(`@@Log: Set contact.email after Post Step1: ${email}`)
          moveOn = true
        }
      } catch (err) {
        if (err.type) {
          newService.promo.error = err.type
          ValidationsAdd(
            [
              this.formState.fields["promoCode2"],
              this.formState.fields["promoCode3"],
            ],
            `NewService${newService.promo.error}`,
            "Validate",
            { validation: { displayType: "OnlyOutline" } }
          )
          SnackAdd(T(`NewService${newService.promo.error}`), "Error", 4000)
          return
        } else {
          moveOn = true
        }
      }
    } else {
      moveOn = true
    }
    if (moveOn) {
      FormSetUnDirty(this.formState)
      ScreenNavigateTo("SVLNewServiceStep2")
    }
  }
  async init() {
    this.screen = "SVLNewServiceStep1"
    this.formType = "SVLNewServiceStep1"
    await super.init()
  }
  async getUI() {
    let fields: { [key in NewServiceStep1FormFieldKeys]: SYSField } = <any>(
      this.formState.fields
    )
    let problemTypeField = fields["problemType"]
    let groupField = fields["group"]

    let requesterEmailField = fields["requesterEmail"]
    let requesterPhoneField = fields["requesterPhone"]

    let planningStartDateField = fields["planningStartDate"]
    let planningSlotsField = fields["planningSlots"]
    let promoCodeField = fields["promoCode"]
    let promoCodeField2 = fields["promoCode2"]
    let promoCodeField3 = fields["promoCode3"]

    let problemType = html`
      <ovl-listcontrol .props=${() => problemTypeField}> </ovl-listcontrol>
    `

    let group = html`
      <ovl-listcontrol .props=${() => groupField}> </ovl-listcontrol>
    `

    let promoCode = html`
      <ovl-textbox .props=${() => promoCodeField}> </ovl-textbox>
    `

    let promoCode2 = html`
      <ovl-textbox .props=${() => promoCodeField2}> </ovl-textbox>
    `

    let promoCode3 = html`
      <ovl-textbox .props=${() => promoCodeField3}> </ovl-textbox>
    `

    let planningStartDate = html`
      <ovl-datebox .props=${() => planningStartDateField}> </ovl-datebox>
    `

    let slots = this.formState.fields["planningSlots"]

    let planningSlotsHint
    if (
      FieldIsVisible(slots) ||
      this.state.app.global.SVL.NewService.slotFinder.noSlotsFound
    ) {
      planningSlotsHint = html` <div
        class="fd-message-strip fd-message-strip--information fadeInControl"
        role="alert"
      >
        <p class="fd-message-strip__text">${T("NewServiceHintSlotfinder")}</p>
      </div>`
    }

    let planningSlots
    if (FieldIsVisible(planningSlotsField)) {
      planningSlots = html`
        <ovl-option .props=${() => planningSlotsField}> </ovl-option>
      `
    }

    let requesterEmail = html`
      <ovl-textbox .props=${() => requesterEmailField}> </ovl-textbox>
    `

    let requesterPhone = html`
      <ovl-textbox .props=${() => requesterPhoneField}> </ovl-textbox>
    `

    let SummaryHint
    if (FormHasVisibleSummaryErrors(this.formState)) {
      SummaryHint = html`
        <ovl-formvalidationhint
          .props=${() => this.formState}
        ></ovl-formvalidationhint>
      `
    }

    let promo
    if (this.state.app.global.SVL.NewService.promo.visible) {
      promo = html`
        <fieldset class="fd-fieldset fadeInControl">
          <legend class="fd-fieldset__legend">
            ${T("NewServicePromoCode")}
          </legend>
          <label class="fd-form-label">${T("NewServicePromoCode")}</label>
          <div class="promocode">
            ${promoCode}
            <div class="promodash">&nbsp;-&nbsp;</div>
            ${promoCode2}
            <div class="promodash">&nbsp;-&nbsp;</div>
            ${promoCode3}
          </div>
        </fieldset>
      `
    }

    return html`
      <div class="fd-layout-panel">
        <itf-newserviceheader></itf-newserviceheader>
        <div class="fd-layout-panel__body">
          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">
              ${T("NewServiceProblem")}
            </legend>
            ${group} ${problemType}
          </fieldset>
          ${promo}
          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">
              ${T("NewServicePlanning")}
            </legend>
            ${planningStartDate} ${planningSlots} ${planningSlotsHint}
          </fieldset>

          <fieldset class="fd-fieldset">
            <legend class="fd-fieldset__legend">
              ${T("NewServiceRequester")}
            </legend>
            ${requesterEmail} ${requesterPhone}
          </fieldset>
        </div>

        ${SummaryHint}
        <div class="fd-layout-panel__footer">
          <button
            class="fd-button"
            ?disabled=${!FormIsValid(this.formState)}
            @click=${(e) => this.handleStep1(e)}
          >
            ${T("NewServiceCreateServiceStep1")}
          </button>
        </div>
        <itf-newservicefooter></itf-newservicefooter>
      </div>
    `
  }
}
